export type SilentMeta = { silent?: boolean };

export const SILENT: SilentMeta = { silent: true };
